import React from 'react';
import PropTypes from "prop-types";
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from "@material-ui/icons/Delete";
import CloudDownload from "@material-ui/icons/CloudDownload";


const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

const UploadDocumentsTable = props => {
  const classes = useStyles();
  const { rows, columns, onDelete, onDownload, type } = props;

  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            {columns.map((column, i) => (
              <TableCell style={column.style} key={i}>{column.label}</TableCell>
            ))}
            <TableCell style={{
              width: '20%'
            }} align="center">Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index) => (
            <TableRow key={index}>
              {columns.map((column) => (
                <TableCell key={column.key} component="th" scope="row">
                  {row[column.key]}
                </TableCell>
              ))}
              <TableCell align="center">
                <IconButton onClick={() => onDownload(row.fileName)}>
                  <CloudDownload fontSize="small" />
                </IconButton>
                <IconButton onClick={() => onDelete(type === 0 ? row.id : row.documentId)}>
                  <DeleteIcon fontSize="small" />
                </IconButton></TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {rows.length <= 0 && <Paper style={{
        display: 'flex',
        justifyContent: 'center',
        padding: 50
      }}>No Data</Paper>}
    </TableContainer >
  );
}

UploadDocumentsTable.propTypes = {
  rows: PropTypes.array,
  onDelete: PropTypes.func,
  onDownload: PropTypes.func,
  columns: PropTypes.array,
  type: PropTypes.number
};

UploadDocumentsTable.defaultProps = {
  rows: [],
  columns: [],
  onDownload: fn => fn,
  onDelete: fn => fn,
  type: 0
};

export default UploadDocumentsTable;